const mediaQueries = {
  mobile: "@media screen and (max-width: 600px)",
  tablet: "@media screen and (min-width: 601px) and (max-width: 1024px)",
  mobileAndTablet: "@media screen and (max-width: 1024px)",
  smallDesktop: "@media screen and (min-width: 1025px) and (max-width: 1300px)",
};

export default mediaQueries;
